import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { catchError, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { Observable, Subject, of } from 'rxjs';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { CustomerService, UserService } from '../../../../_services';
import { AppConfig, CustomValidators, DataService } from '../../../../_helpers';
import { Configuration, DebtorPhonePrefix, DebtorStatus, User, UserCustomerDetail, UserEmailDictionary, UserList, UserRoleList } from '../../../../_models';
import { icons } from '../../../../sharedcomp/constans/icons.constans';
import { DebtorsStatusEnum, DocumentService, debtorPhonePrefix, debtorStatus } from '../../../../_enums';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ConfirmPasswordValidator } from '../../../confirm-password.validator';
import { ChangePassword} from '../../../../_models/index';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-new-user-list',
  templateUrl: './new-user-list.component.html',
  styleUrls: [
    './new-user-list.component.css',
    '../../../../../assets/css/new-badges-chips-theme.css',
    '../../../../../assets/css/new-component-view.css',
    '../../../../../assets/css/new-form-elements.css',
    '../../../../../assets/css/new-buttons-theme.css',
    '../../../../sharedcomp/sidebar/sidebar.component.css'
  ],
  animations: [
    trigger('animationSplit', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(400px)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ opacity: 1, transform: 'translateX(500px)' })),
      ]),
    ]),
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [
        animate(200, style({ opacity: 1 })),
      ]),
    ])
  ],
    providers: [Ng4LoadingSpinnerService]
})
export class NewUserListComponent implements OnInit {

  isalertVisiable = false;
  userKcoreId: any;
  isRoleAdmiReader: any;
  public passwordForm: FormGroup;
  public User_publicid: string;

  customerPublicId: string;
  customerUserPublicId: string;

  displayedColumns: string[] = ['name', 'status', 'email', 'phone', 'role', 'actions'];
  dataSource = new MatTableDataSource<UserList>([]);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayLoaderSpinner: boolean = false;
  totalSize: number = 0;
  pageSize: number;
  PageSizeOptions: number[];

  roleDictionary: UserEmailDictionary[];
  ddlUserRoles: string[];
  tempRoleList: Configuration<UserRoleList>;
  ddldebtorPhonePrefix: any;
  ddlUserStatus: DebtorStatus[];

  getUserRoleList$: Observable<Configuration<UserRoleList>>;
  getCustomerUserList$: Observable<UserList[]>;

  icons: typeof icons;

  userUpdateForm: FormGroup;

  isSidebarVisible: boolean = false;

  isUserCountVisiable: boolean = false;
  userCount: number;
  private destroy$ = new Subject<void>();
  dataRoleAdminTreasury: UserList[];

  constructor(
    private customerService: CustomerService,
    private router: Router,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private _debtorPhonePrefix: debtorPhonePrefix,
    private _debtorStatus: debtorStatus,
    private renderer: Renderer2,
    private dataService: DataService
    , private _fbpass: FormBuilder,
    private documentService: DocumentService
  ) {
    this.userCount = AppConfig.settings.userSetting.userCount;
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.icons = icons;
    this.ddlUserStatus = _debtorStatus.Status;
    this.initUserUpdateForm();
    this.userKcoreId = localStorage.getItem('userId');
    this.isalertVisiable = false;
  }

  ngOnInit() {
    let country = localStorage.getItem("country")
    this.ddldebtorPhonePrefix = this.documentService.getPrefixByIsoAlpha2(country);
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;

    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('isadmin');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      } else {
        this.customerPublicId = localStorage.getItem('companyId');
      }
    } else {
      this.customerPublicId = localStorage.getItem('subcompanyId');
    }

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "Siguiente página";
    this.paginator._intl.lastPageLabel = "Última página";
    this.paginator._intl.previousPageLabel = "Anterior página";
    this.paginator._intl.firstPageLabel = "Primera página";

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.setUserRoleListObservable();
    this.setCustomerUserList();
    this.getUserRoleListAndCustomerUserDetails();
    this.InitialSetup();
    this.getRole();
  }

  InitialSetup() {

      this.passwordForm = this._fbpass.group({
          newPassword: new FormControl("", Validators.compose([
              Validators.required,
              // check whether the entered password has a number
              ConfirmPasswordValidator.patternValidator(/\d/, {
                  hasNumber: true
              }),
              // check whether the entered password has upper case letter
              ConfirmPasswordValidator.patternValidator(/[A-Z]/, {
                  hasCapitalCase: true
              }),
              // check whether the entered password has a lower case letter
              ConfirmPasswordValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
              // check whether the entered password has a special character
              ConfirmPasswordValidator.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
                  {
                      hasSpecialCharacters: true
                  }
              ),
              Validators.minLength(8)
          ])),
          confirmPassword: new FormControl("", Validators.compose([Validators.required]))
      },
          {
              validator: ConfirmPasswordValidator.passwordMatchValidator
          });
  }

  getRole(){
    this.userService.getUser(this.userKcoreId).subscribe((user: User) => {
      this.isRoleAdmiReader = user.role
      console.log(this.isRoleAdmiReader)
  })
}

  getElementPubliID(element: UserList){
    this.User_publicid = element.public_id;
  }

  onsubmitpass({ value }: { value: ChangePassword }) {
    if (value.newPassword != null && value.newPassword != undefined && value.newPassword != "") {
        this.userService.changepassword(this.User_publicid, value).pipe(
          finalize(() => {
            this.passwordForm.reset();
          })
        )
            .subscribe((result) => {
                this.isalertVisiable = true;
            }, error => {
                console.log('Failed while trying to update the user password details.' + error);
            });
    }
}


  cancelCreation(cancel: boolean) {
    if (!cancel) {
      this.isSidebarVisible = cancel;
      this.renderer.removeClass(document.body, 'modal-open');
    }
  }

  openCreateCustomerSidebar() {
    this.renderer.addClass(document.body, 'modal-open');
    this.isSidebarVisible = true;
  }

  numberOnly(event: KeyboardEvent): boolean {
    const key = event.key;
    // Permitir números del 0 al 9
    if (/\d/.test(key)) {
      return true;
    }
    return false;
  }

  initUserUpdateForm() {
    this.userUpdateForm = this.formBuilder.group({
      id: new FormControl("", [Validators.required]),
      name: new FormControl("", [Validators.required]),
      email: new FormControl("Seleccione", [Validators.required, CustomValidators.validateNoPreSelect]),
      phone: new FormControl("", [Validators.required]),
      phone_prefix: new FormControl('Seleccione'),
      role: new FormControl("Seleccione", [CustomValidators.validateNoPreSelect]),
      status: new FormControl("Seleccione", [CustomValidators.validateNoPreSelect]),
      public_id: new FormControl(""),
    });
  }

  getPhoneValue(value: string, stringType: 'countryCode' | 'phoneNumber'): DebtorPhonePrefix['value'] | string | '' {
    if(stringType === 'countryCode'){
      return this.documentService.getCountryCode(value);
    } else if (stringType === 'phoneNumber') {
      return this.documentService.getPhoneNumberOnly(value);
    } else {
      return '';
    }
  }

  setUserUpdateFormValue(data: User<UserCustomerDetail>, inputPrefixPhone) {
    this.userUpdateForm.patchValue({
      id: data.id,
      name: data.name,
      email: data.email,
      phone: data.phone,
      phone_prefix: inputPrefixPhone,
      role: data.role,
      status: data.status,
      public_id: data.public_id
    })
  }

  setNewUserStatus(element: UserList): 'INACTIVE' | 'ACTIVE' {
    const previousStatus = element.status === 'ACTIVE';
    return previousStatus ? 'INACTIVE' : 'ACTIVE';
  }

  updateUserStatus(event, element: UserList) {
    event.preventDefault();
    this.dataService.loadSpinner(true);
    this.userUpdateForm.reset();

    const customerUserStatusPublicId = element.public_id;
    const newStatus = this.setNewUserStatus(element);
    this.getCustomerUser$(customerUserStatusPublicId, 'edit-status', newStatus)
      .pipe(
        switchMap(data => {
          return this.updateUserDetail$(this.userUpdateForm, customerUserStatusPublicId, 'edit-status', element);
        })
      ).subscribe();
  }

  getUserDetail(element: UserList) {
    this.userUpdateForm.reset();
    this.customerUserPublicId = element.public_id;

    this.getCustomerUser$(this.customerUserPublicId)
    .subscribe((data: User<UserCustomerDetail>) => {});
  }

  updateUserDetail(value: FormGroup) {
    this.dataService.loadSpinner(true);
    this.updateUserDetail$(value, this.customerUserPublicId).subscribe();
  }

  updateUserDetail$(value: FormGroup, userPublicId: string, type?: 'edit-status', element?: UserList): Observable<any> {

    const { phone_prefix, phone, ...userForm } = value.getRawValue();
    const newUserForm = { ...userForm, phone: (phone_prefix === 'Seleccione' ? '' : phone_prefix) + phone };

    return this.userService.updateUser(userPublicId, newUserForm)
      .pipe(
        takeUntil(this.destroy$),
        switchMap((data) => {
          if (type === 'edit-status') {
            element.status = data.status;
          }
          return this.getCustomerUserList$;
        }),
        catchError(error => {
          this.dataService.loadSpinner(false);
          console.error('Failed while trying to update user information. ' + error);
          return of([]);
        })
      )
  }

  getUserRoleListAndCustomerUserDetails() {
    this.displayLoaderSpinner = true;
    this.dataService.loadSpinner(true);

    this.getUserRoleList$
      .pipe(
        switchMap((data) => {
          return this.getCustomerUserList$;
        })
      )
      .subscribe();
  }

  getCustomerUserList() {
    this.getCustomerUserList$.subscribe();
  }

  setCustomerUserList() {
    this.getCustomerUserList$ = this.customerService.getCustomerUserList(this.customerPublicId)
      .pipe(
        takeUntil(this.destroy$),
        tap((userList: UserList[]) => {
          let resources = userList;
          this.dataSource.data = resources;
          this.totalSize = resources.length;
          this.dataService.reloadCustomerUsersList(resources);
          this.isUserCountVisiable = this.dataSource.data.length < this.userCount;
          this.displayLoaderSpinner = false;
          this.dataService.loadSpinner(false);
        }),
        catchError(error => {
          this.displayLoaderSpinner = false;
          this.dataService.loadSpinner(false);
          console.error('Failed while trying to the Customer User Details Result. ' + error);
          return of([]);
        })
      )
  }

  getCustomerUser$(customerUserPublicId: string, type: 'edit-status' | 'get-detail' = 'get-detail', status?: 'ACTIVE' | 'INACTIVE'): Observable<User<UserCustomerDetail>> {
    return this.userService.getUser<UserCustomerDetail>(customerUserPublicId)
      .pipe(
        takeUntil(this.destroy$),
        map(data => {
          const inputPrefixPhone = this.getPhoneValue(data.phone, 'countryCode');
          console.log(this.getPhoneValue(data.phone, 'phoneNumber'))
          const inputPhoneNo = this.getPhoneValue(data.phone, 'phoneNumber');

          data.phone = inputPhoneNo;
          data.status = type === 'edit-status' ? status : data.status;
          this.setUserUpdateFormValue(data, inputPrefixPhone);
          return data;
        }),
        catchError(error => {
          this.dataService.loadSpinner(false);
          console.error('Failed while trying to get user information. ' + error);
          return of({});
        })
      )
  }

  setUserRoleListObservable() {
    this.getUserRoleList$ = this.customerService.getUserRoleListObservable(this.customerPublicId)
      .pipe(
        takeUntil(this.destroy$),
        tap((userData: Configuration<UserRoleList>) => {
          this.tempRoleList = userData;
          this.ddlUserRoles = this.tempRoleList.values.user.property_list.role.enum;
          this.roleDictionary = this.tempRoleList.values.user.property_list.role.dictionary;
        }),
        catchError(error => {
          this.displayLoaderSpinner = false;
          this.dataService.loadSpinner(false);
          console.error('Failed while trying to get the User Role List' + error);
          return of({});
        })
      );
  }

  userRoleLabel(role) {
    let roleLable = this.roleDictionary.filter(item => item.value == role)
    return roleLable[0].label;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
